import React, { useState, useEffect, useRef } from 'react';
import { getUUID } from '../../utils/browserUtils';
import './style.scss';

const ChatApp = () => {
  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState('');
  const [loading, setLoading] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const messagesEndRef = useRef(null);
  const chatContainerRef = useRef(null);
  const inputRef = useRef(null);

  const sendMessage = async () => {
    if (input.trim() === '') return;

    const userMessage = { text: input, sender: 'user' };
    setMessages([...messages, userMessage]);
    setInput('');
    setLoading(true);

    try {
      const response = await fetch(
        'https://holidayservice.makemytrip.com/HolidayServices/service/holidays-expert-chat',
        {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            request_id: getUUID(),
            question: input,
          }),
        }
      );
      const data = await response.json();
      if (data.response) {
        const serverMessage = { text: data.response, sender: 'server' };
        setMessages([...messages, userMessage, serverMessage]);
      } else {
        throw new Error('Could not fetch Details');
      }
    } catch (error) {
      const errorMessage = {
        text: `Error: ${error.message ?? 'Could not fetch Details'}`,
        sender: 'server',
      };
      setMessages([...messages, userMessage, errorMessage]);
    } finally {
      setLoading(false);
      inputRef.current?.focus();
    }
  };

  const handleKeyPress = event => {
    if (event.key === 'Enter') {
      sendMessage();
    }
  };

  const toggleVisibility = () => {
    setIsVisible(!isVisible);
  };

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

  useEffect(() => {
    scrollToBottom();
  }, [messages]);

  const handleClickOutside = event => {
    if (chatContainerRef.current && !chatContainerRef.current.contains(event.target)) {
      setIsVisible(false);
    }
  };

  useEffect(() => {
    if (isVisible) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isVisible]);

  return (
    <div>
      {!isVisible && (
        <button onClick={toggleVisibility} id="toggle-button">
          Show Chat
        </button>
      )}
      {isVisible && (
        <div id="chat-container" ref={chatContainerRef}>
          <div id="chat-header">
            <span id="chat-title">Ask me Anything</span>
            <button onClick={toggleVisibility} id="close-button">
              &times;
            </button>
          </div>
          <div id="chat-window">
            <div id="messages">
              {messages.map((msg, index) => (
                <div
                  key={index}
                  className={`message ${msg.sender}-message ${msg.error ? 'error-message' : ''}`}
                >
                  {msg.text}
                </div>
              ))}
              {loading && (
                <div className="loader" id="loader">
                  <span />
                  <span />
                  <span />
                </div>
              )}
              <div ref={messagesEndRef} />
            </div>
          </div>
          <div id="input-container">
            <input
              type="text"
              id="message-input"
              value={input}
              onChange={e => setInput(e.target.value)}
              onKeyPress={handleKeyPress}
              placeholder="Type a message..."
              disabled={loading}
              ref={inputRef}
            />
            <button id="send-button" onClick={sendMessage} disabled={loading}>
              Send
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default ChatApp;
